var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesert1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 54,
    viewBox: "0 0 129 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8588 29.6158L3.50704 16.5135C2.72451 13.4545 3.38925 10.2056 5.31037 7.6998C8.60863 3.39772 14.6783 2.39106 19.1887 5.39805L25.7194 9.75184C25.9862 9.9297 26.1983 10.1783 26.3319 10.4698C29.2421 16.8193 38.414 16.357 40.6711 9.74709L42.0971 5.57078C42.64 3.98103 44.2389 3.00407 45.9012 3.24649L61.1016 5.46321C63.6768 5.83877 66.2919 5.85316 68.8711 5.50595L86.2035 3.17274C88.2788 2.89338 90.3359 3.79871 91.5317 5.51767L92.9689 7.58364C95.8877 11.7794 101.684 12.7571 105.818 9.75093C107.395 8.60433 109.625 9.16895 110.466 10.9276L111.584 13.2642C112.084 14.3102 112.225 15.4918 111.987 16.6264L111.937 16.861C110.85 22.027 113.272 27.2962 117.901 29.8347L123.229 32.757C124.938 33.6939 126 35.4875 126 37.4361V43.1233C126 45.5242 123.163 46.798 121.369 45.203C118.019 42.2255 112.965 42.2478 109.642 45.2545L108.26 46.5044C106.409 48.1791 103.591 48.1791 101.74 46.5044L101.438 46.2315C97.5182 42.6851 91.6647 42.3269 87.3418 45.3689L83.1035 48.3514C81.1166 49.7496 78.7463 50.5 76.3167 50.5H71.3726C67.5844 50.5 63.8374 49.7148 60.368 48.194L35.4062 37.2518C30.9299 35.2896 25.7726 35.6693 21.6319 38.266L15.9811 41.8097C11.4242 44.6674 5.69177 40.5725 6.91753 35.3351C7.35833 33.4517 7.33818 31.4898 6.8588 29.6158Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesert1);
export default __webpack_public_path__ + "static/media/desert1.1a9f30d2.svg";
export { ForwardRef as ReactComponent };